module.exports = __webpack_public_path__ + "img/h5_banner01.b78bff16.webp";